"use strict";

/**
 * @classdesc
 * Sidebar-Panel.
 *
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.ui
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {string} options.label Label für Sidebar-Header
 * @param {jQuery} options.element Anzuzeigendes Element
 * @param {jQuery} [options.launcher=undefined] Launcher-Element dem dieses Panel untergeordnet ist
 * @param {gc.gis.ui.GCSidebarContent} [options.parent=null] Elternpanel
 */
gc.gis.ui.GCSidebarContent = function( options )
{
	this._label = options.label;
	this._parent = options.parent || null;
	this._element = options.element;
	this._launcher = options.launcher || undefined;

	gc.gis.GCObservable.call( this );
};
gc.gis.ui.GCSidebarContent.prototype =
	Object.create( gc.gis.GCObservable.prototype );

/**
 * @public
 * @return {string}
 */
gc.gis.ui.GCSidebarContent.prototype.getLabel = function()
{
	return this._label;
};

/**
 * @public
 * @param {string} label
 */
gc.gis.ui.GCSidebarContent.prototype.setLabel = function( label )
{
	this._label = label;
};

/**
 * @public
 * @return {jQuery}
 */
gc.gis.ui.GCSidebarContent.prototype.getElement = function()
{
	return this._element;
};

/**
 * @public
 * @return {gc.gis.ui.GCSidebarContent|null}
 */
gc.gis.ui.GCSidebarContent.prototype.getParent = function()
{
	return this._parent;
};

/**
 * @public
 * @returns {Object<string,*>}
 */
gc.gis.ui.GCSidebarContent.prototype.getLauncher = function()
{
	return this._launcher;
};

